<div class="gallery-container content-box">
  <a *ngFor="let item of viewData" [routerLink]="linksToThought ? ['/thoughts/', item.thoughtId] : null"><img [src]="item.src" class="gallery-item"></a>
</div>
